export const GAME_KEYS = {
  stage1: 'stage1',
  stage2: 'stage2',
  stage3: 'stage3',
  stage4: 'stage4',
};

export const STALLS = [
  {
    id: 'braille',
    gameKey: GAME_KEYS.stage1,
    route: '/games/braille',
    tile: '/img/Braille.png',
    title: 'Decode the Braille Message',
  },
  {
    id: 'avoid-consider',
    gameKey: GAME_KEYS.stage2,
    route: '/games/avoid-consider',
    tile: '/img/Avoid_Consider.png',
    title: 'Avoid VS Consider',
  },
  {
    id: 'gender-quest',
    gameKey: GAME_KEYS.stage3,
    route: '/games/gender-quest',
    tile: '/img/GenderQuest.png',
    title: 'Gender Quest',
  },
  {
    id: 'diversity',
    gameKey: GAME_KEYS.stage4,
    route: '/games/diversity',
    tile: '/img/Diversity.png',
    title: 'Diversity in Performance',
  },
];

export const STAGE1_ANSWERS = [
  { id: 'ans1', value: 'accessibility', label: 'Accessibility', img: '/stage1/img/Group1.png' },
  { id: 'ans2', value: 'diversity', label: 'Diversity', img: '/stage1/img/Group2.png' },
  { id: 'ans3', value: 'unconscious bias', label: 'Unconscious Bias', img: '/stage1/img/Group3.png' },
  { id: 'ans4', value: 'allyship', label: 'Allyship', img: '/stage1/img/Group4.png' },
  { id: 'ans5', value: 'equity', label: 'Equity', img: '/stage1/img/Group5.png' },
];

export const STAGE2_LEFT = [
  { id: 'leftA', pos: 0, label: 'Whitelist', color: '#b52554' },
  { id: 'leftB', pos: 1, label: 'Minority', color: '#262626' },
  { id: 'leftC', pos: 2, label: 'Blindspot', color: '#4368d2' },
  { id: 'leftD', pos: 3, label: 'Lame', color: '#43d289' },
  { id: 'leftE', pos: 4, label: 'Walkthrough', color: '#f17225' },
  { id: 'leftF', pos: 5, label: 'Disabled', color: '#7c25b3' },
];

/** Display order on the right column (scrambled), correct match is by `pos`. */
export const STAGE2_RIGHT = [
  { id: 'rightD', pos: 3, label: 'Uncool' },
  { id: 'rightE', pos: 4, label: 'Guide through' },
  { id: 'rightC', pos: 2, label: 'Missed Opportunity' },
  { id: 'rightF', pos: 5, label: 'People with disabilities' },
  { id: 'rightB', pos: 1, label: 'Marginalized Groups' },
  { id: 'rightA', pos: 0, label: 'Allow list' },
];

export const STAGE2_ANSWER_LABELS = [
  'Whitelist:- Allow list',
  'Minority:- Marginalized Groups',
  'Blindspot:- Missed Opportunity',
  'Lame:- Uncool',
  'Walkthrough:- Guide through',
  'Disabled:- People with disabilities',
];

export const STAGE3_DROPS = [
  { pos: 0, answer: 'Genderqueer', img: '/stage3/img/1.png', popup: '/stage3/img/GenderQueer.png' },
  { pos: 1, answer: 'Transgender', img: '/stage3/img/2.png', popup: '/stage3/img/Transgender.png' },
  { pos: 2, answer: 'Agender', img: '/stage3/img/3.png', popup: '/stage3/img/Agender.png' },
  { pos: 3, answer: 'Androgyne', img: '/stage3/img/4.png', popup: '/stage3/img/Androgyne.png' },
  { pos: 4, answer: 'Bisexual', img: '/stage3/img/5.png', popup: '/stage3/img/Bisexual.png' },
];

/** Drag chip order as in PHP (scrambled). */
export const STAGE3_DRAGS = [
  { pos: 3, label: 'Androgyne' },
  { pos: 1, label: 'Transgender' },
  { pos: 2, label: 'Agender' },
  { pos: 4, label: 'Bisexual' },
  { pos: 0, label: 'Genderqueer' },
];

export const STAGE4_QUESTIONS = [
  { image: '/stage4/img/1.png', popup: '/stage4/img/1popup.png', ans: 'haka' },
  { image: '/stage4/img/2.png', popup: '/stage4/img/2popup.png', ans: 'djembe' },
  { image: '/stage4/img/3.png', popup: '/stage4/img/3popup.png', ans: 'barynya' },
  { image: '/stage4/img/4.png', popup: '/stage4/img/4popup.png', ans: 'madhubani' },
];

export const GAME_COPY = {
  stage1: {
    title: 'Decode the Braille Message',
    instruction:
      'Provide a sequence of Braille cells with one or more missing. Players must identify and fill in the missing Braille letters to complete the sequence',
    rules: [
      'Fill in missing letters from the Braille in a sequence.',
      'Correct answers turn green, incorrect turn red.',
      'Each correct answer earns 1 point.',
      'You can play multiple times. Score for the first attempt will only be considered',
    ],
  },
  stage2: {
    title: 'Avoid VS Consider',
    instruction:
      'Evolve the user journey by aligning the column term "to reconsider" with its alternative term.',
    rules: [
      'Pair original terms with alternative ones.',
      'To match both columns, first click on the left Culture tabs and then click on the definitions on the right.',
      'You will see a line being drawn to connect both columns.',
      '1 point per correct match.',
      'You can play multiple times. Score for the first attempt will only be considered',
    ],
  },
  stage3: {
    title: 'Gender Quest',
    instruction: 'Identify the correct gender identity based on the provided options',
    rules: [
      'Players should drag and drop to match pairs.',
      'Each correct match earns 1 point.',
      'You can play multiple times. Score for the first attempt will only be considered',
    ],
  },
  stage4: {
    title: 'Diversity in Performance',
    instruction:
      'Identify performances celebrating diverse cultures, abilities, and talents. Guess right and type in the provided box.',
    rules: [
      'Correct answers turn green, incorrect turn red.',
      'Each correct answer earns 1 point.',
      'You can play multiple times. Score for the first attempt will only be considered',
    ],
  },
};

export const HUB_RULES = [
  'Engage in all 4 stalls to earn maximum points',
  'Points are considered for only first attempt on all stalls',
];

export const WELCOME_COPY = {
  title: 'We are thrilled to welcome you to our Virtual Carnival dedicated to the celebration of Inclusion!',
  body: 'This virtual carnival is a celebration of US - our cultures, our traditions, and our unique contributions to our community. Engage in the stalls with open hearts and minds, ready to learn, share, and inspire inclusion in our everyday life.',
};
